import { User, UserManager, UserManagerSettings } from 'oidc-client';
import { environment } from 'src/environments/environment';
import { Client } from '@microsoft/microsoft-graph-client';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { from } from 'rxjs';

export { User };

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  userManager: UserManager;

  constructor() {
    this.userManager = new UserManager(this.getClientSettings());
  }

  public getClientSettings(){
    const settings = {
      authority: environment.stsAuthority,
      client_id: environment.clientId,
      client_secret: environment.ClientSecret,
      redirect_uri: `${environment.clientRoot}redirect`,
      silent_redirect_uri: `${environment.clientRoot}redirect`,
      post_logout_redirect_uri: `${environment.clientRoot}`,
      response_type: 'id_token token',
      scope: environment.clientScope
    };
    return settings;
  }

  public getUser(): Promise<User> {
    return this.userManager.getUser();
  }

  public getUser2(): Observable<User> {
    const observable = from(this.userManager.getUser());
    return observable;
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }
  public loginRedirect(url): Promise<void> {
    return this.userManager.signinRedirect({state:url});
  }


  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public renewToken2(): Observable<User>{
    const observable = from(this.userManager.signinSilent());
    return observable;
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  public getAccessToken(): Promise<string> {
    return this.getUser().then(user => {
      return user.access_token;
    })
  }

  public getIdToken(): Promise<string> {
    return this.getUser().then(user => {
      if(user)
        return user.id_token;
      return;
    })
  }

  public getIdToken2(): Observable<string> {
    const observable = from(this.getUser().then(user => {
      return user.id_token;
    }));
    return observable;
  }


  public async getGraphUser(email): Promise<any>{
    let graphClient = Client.init({
      authProvider: async(done) => {
        let token = await this.getAccessToken()
          .catch((reason) => {
            done(reason, null);
          });
  
        if (token)
        {
          done(null, token);
        } else {
          done("Could not get an access token", null);
        }
      }
    });
    let graphUser = await graphClient.api(`/users/${email}?$select=displayName,department,id,mail,country,companyname`).get();

  let user = graphUser;
  // // Prefer the mail property, but fall back to userPrincipalName
  // user.email = graphUser.mail || graphUser.userPrincipalName;

  return user;
  }
}